import React, { useEffect, useMemo, useState } from 'react';
import emptyListImg from '../../../../assets/images/emptyList.png';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { Plus, Search } from 'react-feather';
import { AppButton } from '../../../general/AppButton/AppButton';
import { COLORS } from '../../../../utils/colors';
import FiledLienTemplatesTable from '../FiledLienTemplatesTable/FiledLienTemplatesTable';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { FiledLienTemplate } from '@dill/dill-shared';
import { useNavigate } from 'react-router-dom';
import { getFiledLienTemplates } from '../../../../redux/services/filedLienTemplatesService';
import { buildSupplierPath } from '../../../../utils/helpers';

const FiledLienTemplates = () => {
  const navigate = useNavigate();
  const { filedLienTemplates } = useAppSelector((state) => state.filedLienTemplates);
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const [searchText, setSearchText] = useState('');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (user && currentSupplier?.id) {
      dispatch(getFiledLienTemplates({ supplierId: currentSupplier?.id || '' }));
    }
    return () => {};
  }, [user?.id, currentSupplier?.id]);

  const searchedFiledLienTemplates: FiledLienTemplate[] = useMemo(() => {
    let filteredFiledLienTemplates: FiledLienTemplate[] = [];
    if (filedLienTemplates && searchText) {
      const searched = filedLienTemplates.filter((filedLienTemplate) => {
        if (
          filedLienTemplate.name &&
          filedLienTemplate.name.toString().toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      filteredFiledLienTemplates = searched;
    } else {
      filteredFiledLienTemplates = filedLienTemplates;
    }

    return filteredFiledLienTemplates;
  }, [filedLienTemplates, searchText]);

  return (
    <div className="h-full p-4 flex ">
      <div className="flex flex-col px-5 py-4 w-full bg-white">
        <div className="flex justify-between">
          <AppInputField
            inputFieldStyles={{ width: '300px' }}
            id="search"
            value={searchText}
            placeholder={'Search '}
            icon={<Search size={15} />}
            onTextChange={(text) => {
              setSearchText(text);
            }}
          />
          <div className="relative">
            <input
              id="upload"
              className="absolute w-full h-full top-0 bottom-0 opacity-0 hover:bg-blue-700"
              type="file"
              accept="application/pdf"
              onChange={(event) => {
                if (!event?.target.files) {
                  return;
                }
                const file = event?.target?.files[0];

                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    const base64String = reader.result;
                    navigate(
                      buildSupplierPath(
                        currentSupplier?.id,
                        '/lienTemplates/templates/addTemplate'
                      ),
                      {
                        state: { pdf: base64String, name: file.name.split('.')[0] },
                      }
                    );
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />
            <AppButton
              text="Add New Template"
              icon={<Plus color={COLORS.WHITE} />}
              onClick={() => {
                // navigate('/lienTemplates/templates/addTemplate', { state: {} });
              }}
            />
          </div>
        </div>

        <FiledLienTemplatesTable filedLienTemplates={searchedFiledLienTemplates} />
      </div>
    </div>
  );
};

export default FiledLienTemplates;
